/**
 * featureFlags.js
 * ──────────────────────────────────────────────────────────────────
 * Single source of truth for env-driven product flags. Read these via
 * the exported helpers — never re-read process.env at the call site so
 * we keep the flag surface auditable in one place.
 *
 * (No live flags currently. Vendor self-service was removed permanently
 *  in the V1 vendor pivot.)
 */

// Single switch for off-path / half-built surfaces. Defaults OFF.
// Flip to true (or set REACT_APP_SHOW_EXPERIMENTAL_FEATURES=true) to restore
// every hidden entry point exactly. HIDE-ONLY: no routes, endpoints, code, or
// data are removed — only UI reachability is gated on this flag.
export const SHOW_EXPERIMENTAL_FEATURES =
  process.env.REACT_APP_SHOW_EXPERIMENTAL_FEATURES === 'true';

